import { getBankAccountHoldersOptions } from '@/utils/getBankAccountHoldersOptions';

export default {
    name: 'BankAccountSelectHolder',

    props: {
        accountType: {
            type: String,
            required: true
        },
        accountInterveners: {
            type: Array,
            required: true
        }
    },

    components: {},

    data() {
        return {
            holder: null,
            holdersOptions: []
        };
    },

    computed: {},

    watch: {},

    mounted() {
        this.getHoldersOptions();
    },

    methods: {
        getHoldersOptions() {
            try {
                if (
                    !this.accountType ||
                    !this.accountInterveners ||
                    !this.accountInterveners.length
                )
                    return null;

                this.holdersOptions = getBankAccountHoldersOptions(
                    this.accountType,
                    this.accountInterveners
                );

                return;
            } catch (err) {
                console.error(err);
                this.$toast.error(`Error: ${err}`);
            }
        },

        getHolderText(holder) {
            if (!holder) return '';

            const fullName = [holder.first_name, holder.lastname_1, holder.lastname_2]
                .filter(Boolean)
                .join(' ')
                .trim();

            return `${fullName} - ${holder.document_id}`;
        },

        onSelectHolder(holder) {
            this.$emit('on:selectedHolder', holder);
        }
    }
};
